<template>
  <div>
    <XVSticky>
      <button
        type="button"
        id="btnterug"
        class="btn btn-primary btn-xs"
        @click="btnterug"
        v-if="this.$route.path.includes('prof')"
      >{{ translation(177) }}</button>
    </XVSticky>
    <div class="row">
      <div class="col-md-12">
        <span id="lblTitel" class="titel">{{ translation(11698) }}</span>
      </div>
    </div>
    <div class="row margin20">
      <div class="col-md-12">
        <span id="lblinfo" v-html="translation(11699)"></span>
      </div>
    </div>
  </div>
</template>

<script>
'use strict'
import { FAMixin } from 'pevueglobal'
// https://pe.xaurum.nl/peapp/public/Spe005PrHelpdesk/55/admin
// https://pe.xaurum.nl/peapp/public/Spe005PrHelpdesk/55/prof
export default {
  mixins: [FAMixin],
  data: function() {
    return {}
  },
  async mounted() {
    this.startLoading({ showmessage: false, disablepage: false })
    this.stopLoading()
  },
  methods: {
    btnterug() {
      window.location = '/SPE001_PR_Inloggen.aspx?css=' + this.$route.params.profgroup
    }
  }
}
</script>
<style>
.public_SPE005PrHelpdesk .stickybar {
  background-color: #fff;
}
</style>
